// extracted by mini-css-extract-plugin
export default {"card":"roblox-module__card--_e95Y","imgContainer":"roblox-module__imgContainer--_66_5","bubble":"roblox-module__bubble--oTicV"};